import React from 'react';

interface BaseCanvasProps {
  id: string;
  text: string;
  fontFamily: string;
  fontSize: number;
  onDataChange: (dataUrl: string, textWidth: number) => void;
}

export const CANVAS_SIGNATURE_COMPONENT_HEIGHT = 42;

const BaseCanvas: React.FC<BaseCanvasProps> = React.memo(
  ({ id, text, fontFamily, fontSize, onDataChange }) => {
    const [textWidth, setTextWidth] = React.useState(0);
    const canvasRef = React.useRef<HTMLCanvasElement | null>(null);

    const clearCanvasContext = (
      canvasElement: HTMLCanvasElement,
      canvasContext: CanvasRenderingContext2D,
    ) => {
      canvasContext.clearRect(0, 0, canvasElement.width, canvasElement.height);
    };

    React.useEffect(() => {
      if (canvasRef.current) {
        const canvas = canvasRef.current;
        const context = canvas.getContext('2d');
        if (context) {
          if (text?.length > 0) {
            // to avoid overlaying we need to clear the existing text
            clearCanvasContext(canvas, context);
            context.font = `${fontSize}px ${fontFamily}`;
            context.fillText(text, 0, 25);
            setTextWidth(context?.measureText(text)?.width);
            onDataChange(canvas?.toDataURL('image/png'), textWidth);
            return;
          }
          // if the text is empty we should clear the canvas
          clearCanvasContext(canvas, context);
        }
      }
    }, [text, textWidth]);

    return (
      <canvas
        id={id}
        ref={canvasRef}
        height={CANVAS_SIGNATURE_COMPONENT_HEIGHT}
        width={textWidth}
      />
    );
  },
);

export default BaseCanvas;
